
import React, { useEffect } from 'react';
import { useBreakpoint } from '@/hooks/use-mobile';
import { toast } from 'sonner';

const TestimonialHeader = () => {
  const { isDesktop, isMobile } = useBreakpoint();
  
  useEffect(() => {
    // Simple approach: load the script directly
    const script = document.createElement('script');
    script.src = 'https://embed.ndrsl.net/ndrsl.js';
    script.async = true;
    
    // Add the script to the document
    document.body.appendChild(script);
    
    // Log for debugging
    console.log('Testimonial script added to document');
    
    return () => {
      // No cleanup needed - leaving the script in the DOM
    };
  }, []);

  return (
    <div className="text-center w-full px-1 sm:px-4 md:px-0">
      <h2 className="sm:text-3xl md:text-4xl font-bold text-[#003a70] mb-3 md:mb-4 leading-tight text-lg">
        What Our Customers Are Saying...
      </h2>
      <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-4 md:mb-6 max-w-3xl mx-auto">
        Real people sharing their experience with AskSpot. See how our platform has transformed their feedback collection and analysis process.
      </p>
      
      <div>
        {isMobile ? (
          <div 
            id='ndrsl-67cef9fa3b24f8708cc2a6c7' 
            className='ndrsl-widget'
            style={{
              maxWidth: '100%',
              margin: '0 auto',
              display: 'block'
            }}
          ></div>
        ) : (
          <div 
            id='ndrsl-67cb2532af38167aac767632' 
            className='ndrsl-widget w-full' 
            style={{
              maxWidth: '100%',
              margin: '0 auto',
              display: 'block'
            }}
          ></div>
        )}
      </div>
    </div>
  );
};

// Add TypeScript interface for the window object to include ndrslInit
declare global {
  interface Window {
    ndrslInit?: () => void;
  }
}

export default TestimonialHeader;
